import { Component } from '@theme/component'
import { isClickedOutside } from '@theme/utils'

const FacetSortConfig = {
  selectors: {
    button: '.sort-by',
    close: '.sort-close',
    radio: 'input[type="radio"][name="sort_by"]',
    selection: '.sort-selection'
  }
}

class FacetSort extends Component {
  connectedCallback() {
    super.connectedCallback()

    this.button = this.querySelector(FacetSortConfig.selectors.button)
    this.selection = this.querySelector(FacetSortConfig.selectors.selection)
    this.closeBtn = this.querySelector(FacetSortConfig.selectors.close)

    if (!(this.button && this.selection)) return

    this.handleButtonClick = this.handleButtonClick.bind(this)
    this.handleCloseClick = this.handleCloseClick.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.handleOutsideClick = this.handleOutsideClick.bind(this)

    this.button.addEventListener('click', this.handleButtonClick)
    this.closeBtn?.addEventListener('click', this.handleCloseClick)
    this.addEventListener('change', this.handleChange)
    document.addEventListener('click', this.handleOutsideClick, true)
  }

  disconnectedCallback() {
    super.disconnectedCallback()
    this.button?.removeEventListener('click', this.handleButtonClick)
    this.closeBtn?.removeEventListener('click', this.handleCloseClick)
    this.removeEventListener('change', this.handleChange)
    document.removeEventListener('click', this.handleOutsideClick, true)
  }

  get isOpen() {
    return this.button?.hasAttribute('open')
  }

  open() {
    this.button?.setAttribute('open', '')
  }

  close() {
    this.button?.removeAttribute('open')
  }

  handleButtonClick(event) {
    event.preventDefault()
    this.isOpen ? this.close() : this.open()
  }

  handleCloseClick(event) {
    event.preventDefault()
    event.stopPropagation()
    this.close()
  }

  handleOutsideClick(event) {
    if (this.isOpen && isClickedOutside(event, this)) {
      this.close()
    }
  }

  handleChange(event) {
    const target = event.target
    if (!(target instanceof HTMLInputElement) || target.name !== 'sort_by') {
      return
    }

    const label = target.nextElementSibling?.textContent?.trim()
    if (label) this.selection.textContent = label

    const url = new URL(window.location.href)
    url.searchParams.set('sort_by', target.value)
    url.searchParams.delete('page')
    window.location.assign(url.toString())
  }
}

if (!customElements.get('ui-facet-sort')) {
  customElements.define('ui-facet-sort', FacetSort)
}
